import React from 'react';
import { Button, Modal, IconWarning } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as S from './BeforeLEavingGatorModal.styles';

const BeforeLEavingGatorModal = ({ onClose, onContinue }) => {
  const { aichat: aichatLocale } = useLocale();
  const { beforeLeaveModal: beforeLeaveModalLocale } = aichatLocale;

  const handleContinue = () => {
    onContinue && onContinue();
    onClose && onClose();
  };

  return (
    <Modal
      withOverflow={false}
      withGap={false}
      maxWidth={500}
      onClose={onClose}
    >
      <S.ModalContent>
        <S.IconWrapper>
          <IconWarning color="problemPure" />
        </S.IconWrapper>

        <S.Title>
          {beforeLeaveModalLocale.title}
        </S.Title>

        <S.Description>
          {beforeLeaveModalLocale.description}
        </S.Description>

        <S.ButtonsWrapper>
          <Button
            size="large"
            label={beforeLeaveModalLocale.continueLabel}
            onClick={onClose}
          />

          <S.CancelButton onClick={handleContinue}>
            {beforeLeaveModalLocale.cancelLabel}
          </S.CancelButton>
        </S.ButtonsWrapper>
      </S.ModalContent>
    </Modal>
  );
};

export default BeforeLEavingGatorModal;
